export const initialValues = {
  search: '',
};

export const mock = [
  {
    id: 1,
    name: 'search',
    placeholder: 'Search',
    fieldType: 'defaultSearch',
    classNames: 'w-[48%] sm:w-[30%] md:w-[30%]',
  },
];
